import { useMemo } from "react";

import { getDeploymentType } from "../utils/get-deployment-type.ts";

export const useDeploymentType = () => {
	const deploymentType = useMemo(() => getDeploymentType(), []);
	return {
		deploymentType,
		isInternal: deploymentType.trim() === "internal",
	};
};
